export function countryReducer(state, action) {
  switch (action.type) {
    case "load":
      return {
        ...state,
        countries: action.countries,
      };
    default:
      throw new Error();
  }
}
